<template>
    <div class="logout-page">
        <!-- <mt-header fixed title="注销账号" style="background:#ffffff;color:#262626;padding: 0 20px">
            <router-link to="/" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
        </mt-header> -->

        <div class="main-section">
            <h1>用户注销说明</h1>

            <p>亲爱的用户，您好</p>

            <p>由于近期欧盟颁布了信息安全法案，我们也为国外需要注销的用户提供了如下方式申请注销。</p>

            <p>
                用户注销意味着您在我们App和平台中的所有数据都会被删除（包括且不仅限于您的订单、反馈意见、检测报告等信息），且后续如果您使用此账户再次注册登录后，会形成一个全新的账号，不再会包含以上括号中提及的信息。你是否确认需要注销？
            </p>

            <p>
                如果您需要注销，请将您注册时的账号发到此邮箱：<a href="mailto:guoshixiongkefu@163.com">guoshixiongkefu@163.com</a>，我们接到您的申请后会主动与您联系指导您一步步注销；如果不需要注销，直接返回上一级页面即可。
            </p>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            
        }
    },
    mounted(){

    },
    created(){
        
    },
    methods:{
        
    },
    components:{
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/base.scss';
.logout-page {
    padding-bottom: 10px;
    .main-section{
        padding:20px 20px 0;
    }
    .main-section > h1 {
        color: #262626;
        font-size: 18px;
        font-weight: bold;
    }
    .main-section > p {
        font-size: 14px;
        color: #262626;
        line-height: 21px;
        margin-top: 16px;
    }
}
a {
    color: #3189ff;
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/static/guoshixiong/Logout.vue